/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  SkillInsightMetrics,
  SkillInsightMetrics$inboundSchema,
} from "./skillinsightmetrics.js";
import {
  SkillInsightPoint,
  SkillInsightPoint$inboundSchema,
} from "./skillinsightpoint.js";

export type SkillVersionInsight = {
  metrics: SkillInsightMetrics;
  skillVersionId: string;
  trend: Array<SkillInsightPoint>;
};

/** @internal */
export const SkillVersionInsight$inboundSchema: z.ZodMiniType<
  SkillVersionInsight,
  unknown
> = z.pipe(
  z.object({
    metrics: SkillInsightMetrics$inboundSchema,
    skill_version_id: z.string(),
    trend: z.array(SkillInsightPoint$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "skill_version_id": "skillVersionId",
    });
  }),
);

export function skillVersionInsightFromJSON(
  jsonString: string,
): SafeParseResult<SkillVersionInsight, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillVersionInsight$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillVersionInsight' from JSON`,
  );
}
